

















export default {
    props: {
        response: Object,
        params: Object,
    },
    computed: {
        computeTitelStyle(this: any) {
            const ret = { Success: false, Warning: false, Error: false };
            switch (this.response.TypeOfActivation) {
            default:
                ret.Error = true; break;
            case 0:
                ret.Success = true; break;
            case 1:
                ret.Warning = true; break;
            case 2:
                ret.Warning = true; break;
            case 3:
                ret.Error = true; break;
            }
            return ret;
        },
        computeTitelIcon(this: any) {
            let ret = {};
            switch (this.response.TypeOfActivation) {
            default:
                ret = { 'el-icon-circle-close': true }; break;
            case 0:
                ret = { 'el-icon-circle-check': true }; break;
            case 1:
                ret = { 'el-icon-remove': true }; break;
            case 2:
                ret = { 'el-icon-remove': true }; break;
            case 3:
                ret = { 'el-icon-circle-close': true }; break;
            }
            return ret;
        },
    },
};
